import {
  SalesSettingsByArea,
  Wrapper,
} from '@/modules/AdminTools/modules/SalesSettingsByArea';

import { abilityConstants } from '@/lib';

const { ACCESS_PLAN_BUILDER_ABILITY } = abilityConstants;

export const PATH = '/sales-settings-by-area';

export const NAME = 'Sales Settings by Area';

export const routes = (protectedRoute, layout) => ({
  path: PATH,
  element: layout,
  children: [
    {
      element: protectedRoute(
        <Wrapper />,
        ACCESS_PLAN_BUILDER_ABILITY,
      ),
      children: [
        {
          index: true,
          element: <SalesSettingsByArea />,
        },
      ],
    },
  ],
});
